<div class="mt-2">
  <div class="row">
    <div class="col-md-9 mt-3 w-100">
      <h4 class="title"><i class="fas fa-download"></i> {{title | translate}}</h4>
    </div>
  </div>
</div>
<div class="bg-white-radius">
  <div class="row mt-2">
    <div class="col-md-2 custom-col-md" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}:</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-university"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="downloadGroup.partnerId"
                (ngModelChange)="reloadEnterprises()">
          <option *ngFor="let partner of partners" [ngValue]="partner.id">{{partner.name | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-4" *ngIf="hasRole(ROLE_PARTNER) || hasRole(ROLE_SUPERADMIN)">
      <label class="font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}:</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="downloadGroup.enterpriseId"
                (ngModelChange)="reloadGroupDocuments()">
          <option *ngFor="let enterprise of enterprises"
                  [ngValue]="enterprise.id">{{ enterprise.name | translate }}</option>
        </select>
      </div>
    </div>
  </div>
  <ul class="list-group list-group-flush">
    <li class="list-group-item" *ngFor="let downloadGroup of downloadGroups; let index=index">
      <div class="col">
        <b>{{index + 1}}</b> {{ "LABEL.FROM-THE" | translate}}
        <b><i>{{index * downloadGroup.groupSize + 1}}</i></b> {{ "LABEL.TO-THE" | translate}}
        <b><i>{{index * downloadGroup.groupSize + downloadGroup.size}}</i></b>,
        {{ "LABEL.QUANTITY-OF-RECORDS" | translate}}:
        &nbsp; <span class="badge badge-primary badge-pill">{{downloadGroup.size}}</span>&nbsp;&nbsp;
      </div>
      <div class="col">
        <a href="javascript:" class="col-md-6"
           (click)="downloadFiles(downloadGroup)"><i
          class="fa fa-file-download"></i> {{ "LINK.DOWNLOAD-FILES" | translate}}
        </a>&nbsp;
        <a href="javascript:" class="col-md-6"
           (click)="downloadMetadata(downloadGroup)"><i
          class="fa fa-file-download"></i> {{ "LINK.DOWNLOAD-METADATA" | translate}}
        </a>
      </div>
    </li>
  </ul>
</div>
<app-loading *ngIf="loading"></app-loading>
